import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import InfoListItem from '../../../info-banner';

function FileRow({ item, onDelete }) {
  const { t } = useTranslation('components');
  function handleDelete() {
    onDelete(item.id);
  }

  function getShortText(){
    if (item.name.length > 20){
      return `${item.name.slice(0,10)}...${item.name.slice(-10)}`;
    }

    return item.name;
  }

  return (
    <InfoListItem styling="primary">
      <div className="file-row">
        {item.type.includes('image') && (
          <img alt="Uploaded file preview" src={URL.createObjectURL(item)} />
        )}
        <span className="text-file">{getShortText()}</span>
        <button className="delete-file" onClick={handleDelete} type="button">
          {t('fileDisplay.deleteButton')}
        </button>
      </div>
    </InfoListItem>
  );
}

FileRow.propTypes = {
  item: PropTypes.shape({
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired
  }).isRequired,
  onDelete: PropTypes.func.isRequired
};

function FileDisplay({ files, onDelete }) {
  if (files === null || files.length === 0) {
    return null;
  }

  return (
    <div className="files-row">
      {files.map(item => (
        <FileRow item={item} key={item.id} onDelete={onDelete} />
      ))}
    </div>
  );
}

FileDisplay.propTypes = {
  files: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onDelete: PropTypes.func.isRequired
};

export default FileDisplay;
